import { createFileRoute, Outlet } from '@tanstack/react-router'

// The run monitor's pages share one crumb, "Approval requests" (each page checks workflows.runs).
export const Route = createFileRoute('/_app/workflows/runs')({
  staticData: { crumb: 'approvalRuns' },
  component: Outlet,
})
